import { render, staticRenderFns } from "./MaskTool.vue?vue&type=template&id=1fa53157&scoped=true&"
import script from "./MaskTool.vue?vue&type=script&lang=js&"
export * from "./MaskTool.vue?vue&type=script&lang=js&"
import style0 from "./MaskTool.vue?vue&type=style&index=0&id=1fa53157&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa53157",
  null
  
)

export default component.exports